import type { FaceId, ListId, SampleId } from '@vlabs/api/luna-api/model';
import type { CardId } from '@vlabs/api/point-api/model';

import { checkCardFaceDuplicates } from './checkCardFaceDuplicates';
import { createFaceFromSample } from './createCardFaceFromSample';

export const createCardFace = async ({
  sampleId,
  cardId,
  lists = undefined,
}: {
  sampleId: SampleId;
  cardId: CardId;
  lists?: ListId[];
}): Promise<FaceId | undefined> => {
  try {
    await checkCardFaceDuplicates({ cardId, sampleId });
  } catch {
    return undefined;
  }
  const faceId = await createFaceFromSample({ cardId, sampleId, lists });
  return faceId;
};
